export const environment = {
    production: false,
    urlApi: 'https://api.development.hub.atsinformatica.com.br/ats-resulth-car-api-mobile',
};
